import { createRouter, createWebHistory } from 'vue-router'
import Home from '../views/Home.vue'
import BigFish from '../views/BigFish.vue'
import SameBoard from '../views/SameBoard.vue'
import Pool from '../views/Pool.vue'
import Dahai from '../views/Dahai.vue'
import Fenglang from '../views/Fenglang.vue'
import Jijing from '../views/Jijing.vue'
import Guanshi from '../views/Guanshi.vue'
import Redian from '../views/Redian.vue'
import Investment from '../views/Investment.vue'
import Hot from '../views/Hot.vue'
import Youzi from '../views/Youzi.vue'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/sameboard',
    name: 'SameBoard',
    component: SameBoard
  },
  {
    path: '/dahai',
    name: 'Dahai',
    component: Dahai
  },
  {
    path: '/fenglang',
    name: 'Fenglang',
    component: Fenglang
  },
  {
    path: '/bigfish',
    name: 'BigFish',
    component: BigFish
  },
  {
    path: '/jijing',
    name: 'Jijing',
    component: Jijing
  },
  {
    path: '/pool',
    name: 'Pool',
    component: Pool
  },
  {
    path: '/guanshi',
    name: 'Guanshi',
    component: Guanshi
  },
  {
    path: '/redian',
    name: 'Redian',
    component: Redian
  },
  {
    path: '/investment',
    name: 'Investment',
    component: Investment,
    meta: { title: '投资' }
  },
  {
    path: '/hot',
    name: 'Hot',
    component: Hot,
    meta: { title: '热门' }
  },
  {
    path: '/youzi',
    name: 'Youzi',
    component: Youzi,
    meta: { title: '游资' }
  },
  {
    path: '/:pathMatch(.*)*',
    redirect: '/'
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

export default router
